import { render, staticRenderFns } from "./ColorTemperatureSwatch.vue?vue&type=template&id=26b7c611"
import script from "./ColorTemperatureSwatch.vue?vue&type=script&lang=js"
export * from "./ColorTemperatureSwatch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports